<template>
  <div>
    <set-nav-bar :typeId="code" :step="steps"></set-nav-bar>
    <div class="info-content">
      <div v-if="showVisitCard">
        <van-cell-group>
          <van-field
            v-model="hosMrNo"
            :label="labelMrNo"
            :placeholder="'请输入' + labelMrNo"
            required
            @input="inputMrNo"
            :right-icon="alertMrNo"
            @click-right-icon="showErrorMsg('userMrNo')"
            color="red"
          >
            <template #button>
              <div
                class="btn-history"
                @click="isShowHistory = true"
                v-show="isShowHistoryBtn"
              >
                住院记录
              </div>
            </template>
          </van-field>
          <div class="van-cell">
            <div class="eg">{{ tmpMsg }}</div>
          </div>
          <van-field
            v-model="patientFlowNo"
            :label="flowName"
            v-if="isShowFlowId"
            :placeholder="'请输入' + flowName"
            required
            :right-icon="alertFlowNo"
            @input="inputFlowNo"
            @click-right-icon="showErrorMsg('userFlowNo')"
            color="red"
          />
          <div class="van-cell" v-if="isShowFlowId">
            <div class="eg">{{ tmpMsg2 }}</div>
          </div>
          <!-- 时间选择模块开始 -->
          <!-- required -->
          <van-field
            v-if="isYPD"
            readonly
            clickable
            name="datetimePicker"
            :value="inDateValue"
            label="就诊日期"
            
            placeholder="请点击选择就诊日期"
            @click="showPicker = true"
          />
          <van-popup v-model="showPicker" position="bottom">
            <van-datetime-picker
              v-model="currentDate"
              type="date"
              :min-date="minDate"
              :max-date="maxDate"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
          <div v-if="isYPD == false">
            <div v-if="isShowStatus">
              <van-field
                name="radio"
                label="出院状态"
                required
                v-if="isShowOutDateStatus"
              >
                <template #input>
                  <van-radio-group v-model="radio" direction="horizontal">
                    <van-radio
                      name="1"
                      checked-color="#07c160"
                      @click="radioClick(radio)"
                      >已出院</van-radio
                    >
                    <van-radio
                      name="2"
                      checked-color="#07c160"
                      @click="radioClick(radio)"
                      >未出院</van-radio
                    >
                  </van-radio-group>
                </template>
              </van-field>
              <div class="van-cell" v-show="!isShowOutDate">
                <div class="eg">
                  如果患者还没有出院，申请将在患者出院后才能办理，请在出院后，及时在公众号向客服提供出院时间！
                </div>
              </div>
            </div>
            <div class="input-group-title bg-my-gray" v-else>
              就诊时间范围选择
            </div>
            <!--  required -->
            <van-field
              readonly
              clickable
              name="datetimePicker"
              :value="inDateValue"
              :label="dateName1"
              :required = "requiredInDate"
              :placeholder="datePlaceholder1"
              @click="showPicker = true"
            />
            <van-popup v-model="showPicker" position="bottom">
              <van-datetime-picker
                v-model="currentDate"
                type="date"
                :min-date="minDate"
                :max-date="maxDate"
                @confirm="onConfirm"
                @cancel="showPicker = false"
              />
            </van-popup>
            <van-field
              readonly
              clickable
              name="datetimePicker"
              v-show="isShowOutDate"
              :value="outDateValue"
              :required = "requiredOutDate"
              :label="dateName2"
              :placeholder="datePlaceholder2"
              @click="showPicker2 = true"
            />
            <van-popup v-model="showPicker2" position="bottom">
              <van-datetime-picker
                v-model="currentDate2"
                type="date"
                :min-date="minDate2"
                :max-date="maxDate2"
                @confirm="onConfirm2"
                @cancel="showPicker2 = false"
              />
            </van-popup>
            <div class="van-cell" v-show="isShowOutDateStatus == false">
              <div class="eg">
                <span style="color: red">注：</span
                >若患者存在多次住院情况，在下一步患者留言一栏中备注！
              </div>
            </div>
          </div>
          <!-- 时间选择模块结束 -->

          <!-- 科室开始 -->
          <van-field
            v-model="hosDep"
            :label="userHosDep"
            :placeholder="depPlaceholder"
            :required="hosDepRequired"
            :readonly="readonlyDep"
            @click="selectDep"
            :is-link="showArrow"
          />
          <van-popup v-model="showDepPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="hosDepList"
              @confirm="onConfirmDep"
              @cancel="showDepPicker = false"
              @change="onChange"
            />
            <!-- :columns="hosDepName" -->
          </van-popup>
        </van-cell-group>
        <!-- 科室结束 -->
      </div>
      <!-- 中药服数开始 -->
      <van-field
        readonly
        clickable
        name="herbal"
        v-if="isShowHerbal"
        :value="herbalItem"
        :label="herbalName"
        required
        is-link
        @click="showHerbalPicker = true"
      />
      <van-popup v-model="showHerbalPicker" position="bottom">
        <van-picker
          show-toolbar
          :columns="herbalNum"
          @confirm="onHerbalConfirm"
          @cancel="showHerbalPicker = false"
          @change="onHerbalChange"
        />
      </van-popup>
      <!-- 中药服数结束 -->
      <!-- 手机号码验证开始 -->
      <div class="input-group-title">手机号码验证</div>
      <van-cell-group>
        <van-field
          v-model="tel"
          label="手机号"
          type="tel"
          required
          placeholder="请输入手机号码"
          @input="inputPhoneNo"
          :right-icon="alertPhoneNo"
          @click-right-icon="showErrorMsg('phoneNo')"
          color="red"
        />
        <van-field
          v-model="verifyCode"
          type="tel"
          center
          clearable
          placeholder="请输入短信验证码"
        >
          <van-button
            slot="button"
            size="small"
            type="primary"
            :disabled="disabledCode"
            @click="onGetVerifyCodeImage"
            >{{ codeText }}</van-button
          >
        </van-field>
      </van-cell-group>
      <!-- 手机号码验证结束 -->
      <!-- 留言开始 -->
      <div class="message" v-if="isYPD">
        <van-field
          v-model="message"
          rows="2"
          autosize
          error
          type="textarea"
          maxlength="100"
          :placeholder="placeholder"
          show-word-limit
        />

        <!-- 留言结束 -->
        <!-- 相关条款开始 -->

        <div class="agreeCheckbox" v-if="isYPD">
          <van-checkbox v-model="agree" shape="square" checked-color="#1aad19"
            >阅读并同意</van-checkbox
          >
          <span class="terms" @click="isShowTerms = true">《相关条款》</span>
        </div>
      </div>
      <div
        id="about"
        class="overlay"
        v-show="isShowTerms"
        @click="isShowTerms = false"
      >
        <!--<div class="weui-popup__overlay"></div>-->
        <div class="floatDiv">
          <div v-html="html"></div>
        </div>
      </div>
      <!-- 相关条款结束 -->
      <div class="bottom-view"></div>
      <van-button
        type="primary"
        color="#1aad19"
        size="large"
        class="btn-next"
        :loading="isLoading"
        loading-text="加载中..."
        :disabled="disabledSubmit"
        safe-area-inset-bottom
        @click="next"
        >下一步</van-button
      >
    </div>
    <div
      class="hos-history_flayer"
      @click="isShowHistory = false"
      v-show="isShowHistory"
    >
      <div class="flayer_content">
        <div class="flayer_title">住院记录</div>
        <div class="flayer_title_say">
          如果您申请的病历不在此住院记录范围内，请手动填写住院号以及出、入院时间！
        </div>
        <div class="flayer_latest_note">
          <div class="flayer_latest_note_l">
            <span class="flayer_latest_note_t1">最新</span>
            <span class="flayer_latest_note_t2">记录</span>
          </div>
          <div class="flayer_latest_note_r">
            <div class="flayer_latest_note_no">
              <div class="name">
                <span class="name-text">住院号</span>
              </div>
              <span class="num">{{ defaultHistory.mrNo }}</span>
              <div class="btn-one-add" @click.stop="addHistory(defaultHistory)">
                一键添加
              </div>
            </div>
            <div class="flayer_latest_note_no">
              <div class="name">
                <span class="name2-text">住院时间</span>
              </div>
              <span class="time">{{
                defaultHistory.hosInDate + " ~ " + defaultHistory.hosOutDate
              }}</span>
            </div>
          </div>
        </div>
        <div class="hos-note-year" v-for="item in hosRecords" :key="item.key">
          <div class="hos-note-year-head">{{ item.hosRecords.year }}</div>
          <!-- 时间轴 -->
          <div class="list-container">
            <div
              class="note-item"
              v-for="item in item.hosRecords.data"
              :key="item.inHosTImes"
            >
              <div class="dotline">
                <div class="line"></div>
                <div class="dot"></div>
              </div>
              <div class="flayer_latest_note time-line-list">
                <div class="flayer_latest_note_r">
                  <div class="flayer_latest_note_no">
                    <div class="name">
                      <span class="name-text">住院号</span>
                    </div>
                    <span class="num">{{ item.mrNo }}</span>
                    <div class="btn-one-add" @click.stop="addHistory(item)">
                      一键添加
                    </div>
                  </div>
                  <div class="flayer_latest_note_no">
                    <div class="name">
                      <span class="name2-text">住院时间</span>
                    </div>
                    <span class="time">{{
                      item.hosInDate + "~" + item.hosOutDate
                    }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 住院记录 -->

    <!-- 验证码代码 {{validation}} -->
    <div class="overlay" id="overlayId" v-if="validation">
      <div class="floatDivInfo">
        <div class="tip-content">
          <div class="tip-title">
            <img
              :src="validationImage"
              style="width: 300px; height: 150px"
            />
          </div>
          <div class="tip-con-info">

            <input
              class="inputVer"
              type="number"
              placeholder="请输入验证结果"
              v-model="validationInputV"
              @input="validationInput()"
            />
            <img v-if="rightok" src="../assets/rightok.png" class="rightok" />
          </div>
          <div class="tipInputVer" v-if="validationTip">请输入正确的验证码</div>
          <div class="tip-button">
            <button
              class="button-2"
              :class="(agreeButton == true)? 'button-no-2':'button-2'"
              type="primary"
              :disabled="agreeButton"
              @click="getSmsCode()"
            >
              确定
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 验证码代码 -->
  </div>
</template>

<script>
import SetNavBar from "../components/SetNavBar.vue";
import md5 from "js-md5";
import Vue from "vue";
import { Dialog } from "vant";
import {
  Field,
  RadioGroup,
  Radio,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Popup,
  Notify,
} from "vant";
Vue.use(Field);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(DatetimePicker);
Vue.use(Popup);
Vue.use(Notify);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
// let vLibId = '';
let hosItem = {};
let tmpNoRole2 = "";
let flowNoHint = "";
let mrNoRule = "";
let mrNoHint = "";
let intervalProcess;
let phoneJson = new Object();
let hosFlowId = "";
let userInfo = {};
let herbels = [];
let step = "";
export default {
  data() {
    return {
      validation: false,
      validationImage: "",
      rightok: false,
      validationInputV: "",
      agreeButton: true,
      captchaImage: "",
      codeValueImage: "",
      validationTip: false,
      code: "",
      steps: 3,
      username: "",
      radio: "1",
      inDateValue: "",
      outDateValue: "",
      showPicker: false,
      showPicker2: false,
      minDate: new Date(1949, 10, 1),
      maxDate: getCurrenDate(),
      minDate2: new Date(1949, 10, 1),
      maxDate2: new Date(2020, 10, 1),
      currentDate: new Date(),
      currentDate2: new Date(),
      hosMrNo: "",
      hosDep: "",
      verifyCode: "",
      tel: "",
      isShowOutDate: true,
      labelMrNo: "",
      isShowOutDateStatus: true,
      tmpMsg: "",
      userHosDep: "科室",
      hosDepRequired: false,
      requiredInDate:false,
      requiredOutDate:false,
      depPlaceholder: "如果不清楚可以不填",
      patientFlowNo: "",
      flowName: "",
      tmpMsg2: "",
      isShowFlowId: false,
      alertMrNo: "",
      alertFlowNo: "",
      alertPhoneNo: "",
      codeText: "获取验证码",
      disabledCode: false,
      isShowHistory: false,
      isShowHistoryBtn: false,
      defaultHistory: {},
      hosRecords: [],
      isShowStatus: true, //是否显示出院状态相关内容
      dateName1: "入院时间",
      datePlaceholder1: "点击选择入院时间",
      dateName2: "出院时间",
      datePlaceholder2: "点击选择出院时间",
      isYPD: false, //是否为药品达程序
      showHerbalPicker: false,
      herbalNum: [],
      herbalItem: "",
      herbalName: "几服中药",
      isShowHerbal: false,
      num: "", //选择的中药数目
      placeholder: "患者留言：选填您对申请的特殊要求",
      message: "",
      agree: false,
      isShowTerms: false,
      html: '<br><h3 style="text-align: center;">药品达免责声明</h3><br><ol><li class="li-read">一切移动客户端（APP，微信等）用户在下载或是关注公众号，并浏览APP、微信公众号中的相应《相关条款》均被视为已经仔细阅读本条款并完全同意。凡以任何方式登陆本APP、微信公众号，或是使用本药品达软件者，均被视为自愿接受本网站相关声明和用户服务协议的约束。</li><li class="li-read">为完成业务申请，患者用户提供的文字、图片、音视频等资料，均由患者提供，其真实性、准确性和合法性由信息发布人负责。药品达不提供任何保证，并不承担任何法律责任。</li><li class="li-read">药品达所转载的文字、图片、音视频等资料，如果侵犯了第三方的知识产权或其他权利，责任由作者或转载者本人承担，药品达对此不承担责任。</li><li class="li-read">药品达不保证为向用户提供便利而设置的外部链接的准确性和完整性，同时，对于该外部链接指向的不由药品达实际控制的任何网页上的内容，药品达不承担任何责任。</li><li class="li-read">药品达注明之服务条款外，其它因不当使用药品达而导致的任何意外、疏忽、合约毁坏、诽谤、版权或其他知识产权侵犯及其所造成的任何损失，药品达概不负责，亦不承担任何法律责任。</li><li class="li-read">对于因不可抗力或因黑客攻击、通讯线路中断等药品达不能控制的原因造成的网络服务中断或其他缺陷，导致用户不能正常使用药品达，药品达不承担任何责任，但将尽力减少因此给用户造成的损失或影响。</li><li class="li-read">本声明未涉及的问题请参见国家有关法律法规，当本声明与国家有关法律法规冲突时，以国家法律法规为准。</li><li class="li-read">本网站相关声明版权及其修改权、更新权和最终解释权均属药品达项目所有者北京凯华公司所有。</li></ol><br>',
      showVisitCard: true,
      isLoading: false,
      disabledSubmit: false,
      name: "",
      maxOut: 7,
      hosLimitOutHosDay: "",

      // name: "",
      hosDepList: [],
      readonlyDep: false,
      hosDepName: [],
      showDepPicker: false,
      showArrow: false,
      patientHosDepCode: "",
      columns: [
        {
          text: "浙江",
          children: [
            {
              text: "杭州",
            },
            {
              text: "温州",
            },
          ],
        },
        {
          text: "福建",
          children: [
            {
              text: "福州",
            },
            {
              text: "厦门",
            },
          ],
        },
      ],
       // 埋点
       mdreferrer:'',
      mdreferrer_title:'',
      // qrView:''
      isFirstDay:false,
    };
  },
  components: {
    SetNavBar,
  },
  beforeRouteEnter(to, from, next) {
    console.log("beforeRouteEnter");
    console.log("thisInBeforeRouteEnter", this);
    next((vm) => {
      console.log("thisInBeforeRouteEnterNext", this);
      console.log("vm", vm);
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
      // console.log(vm.getMsg());
      vm.mdreferrer= from.path;
      if(from.name == '' || from.name == null || from.name ==undefined){
        vm.mdreferrer_title = '无上一页'
      }else{
        vm.mdreferrer_title = from.name
      }
      console.log("dataDataInBeforeRouteEnter  ", vm.mdreferrer);
    });
  },
  created() {
    // vLibId = this.
    let wxId = localStorage.getItem("wxId");
    if (wxId == "13" ||wxId == "45" ) {
      this.isYPD = true;
      this.isShowHerbal = true;
      this.inDateValue = this.$util.formatTime1(getCurrenDate());
      this.inDateValue = this.inDateValue.replace(/\//g, "-");
    }

    let hosItemStr = localStorage.getItem("HosItem");
    hosItem = JSON.parse(hosItemStr);
    this.code = hosItem.code;
    // if (hosItem.hosId == "1819" || hosItem.hosId == "1618") {
    //   this.showVisitCard = false;
    // }
    let userJson = localStorage.getItem("UserInfo");
    if (userJson != null) {
      userInfo = JSON.parse(userJson);
      this.initData();
    }
    let selectHbsType = hosItem.selectHbsType;
    let existHosInOutTime = selectHbsType.hosInfo.existHosInOutTime; //出院状态是否显示（数值为1出院必选）
    this.hosLimitOutHosDay = selectHbsType.hosInfo.hosLimitOutHosDay; //出院时间限制到当前时间后的第几天
    console.log(this.hosLimitOutHosDay);
    if (
      this.hosLimitOutHosDay != "" &&
      this.hosLimitOutHosDay != undefined &&
      this.hosLimitOutHosDay != null
    ) {
      this.maxOut = this.hosLimitOutHosDay;
    } else {
      this.maxOut = 7;
    }
    this.maxDate = getCurrenDate();
    this.maxDate2 = addDate(this.maxDate, this.maxOut);
    hosFlowId = selectHbsType.hosInfo.hosFlowId; //hosFlowId 为1时显示流水号
    let isAccessPatientInfo = this.$util.normalString(
      selectHbsType.hosInfo.isAccessPatientInfo
    ); //是否含有病历历史记录，1为有
    if (hosFlowId == 1) {
      this.isShowFlowId = true;
    }
    let flowNo = selectHbsType.flowNo;
    if (hosFlowId == 1 && this.$util.isNullString(flowNo) == false) {
      this.flowName = flowNo.name;
      this.tmpMsg2 = flowNo.mrNoExample;
      tmpNoRole2 = flowNo.mrNoRule;
      flowNoHint = flowNo.mrNoHint;
    }
    if (existHosInOutTime == 1) {
      this.isShowOutDateStatus = false;
    } else {
      this.isShowOutDateStatus = true;
    }
    // 根据业务类型判断不同的输入时间名称
    // let type = selectHbsType.type;
    // if (type == "HB_TYPE_MR_C") {
    //   // this.setData({
    //   //   dateName1: '开始时间',
    //   //   dateName2: '截止时间',
    //   //   datePlaceholder1: '请选择开始时间',
    //   //   datePlaceholder2: '请选择截止时间',
    //   //   isShowStatus: false
    //   // })
    //   this.isShowStatus = false;
    //   this.dateName1 = "开始时间";
    //   this.dateName2 = "截止时间";
    //   this.datePlaceholder1 = "点击选择开始时间";
    //   this.datePlaceholder2 = "点击选择截止时间";
    // }
    // // 获取科室名称、入院时间名称、出院时间名称
    let userHosDep = selectHbsType.mrNo.hosDepartmentName
    let dateName1 = selectHbsType.mrNo.hosInDateName
    let dateName2 = selectHbsType.mrNo.hosOutDateName
    if(this.$util.isNullString(userHosDep) == false){
      this.userHosDep = userHosDep
    }
    if(this.$util.isNullString(dateName1) == false){
      this.dateName1 = dateName1
    }
    if(this.$util.isNullString(dateName2) == false){
      this.dateName2 = dateName2
    }
    this.labelMrNo = selectHbsType.mrNo.name;
    this.tmpMsg = selectHbsType.mrNo.mrNoExample;
    mrNoRule = selectHbsType.mrNo.mrNoRule;
    mrNoHint = selectHbsType.mrNo.mrNoHint;
    console.log(mrNoHint);
    this.getHosDepList();
    requiredJudgeInit(selectHbsType, this);
    if (isAccessPatientInfo == 1) {
      this.getHosMrRecords();
    }
    console.log(this.$route);
  },
  mounted(){
    var everypage = JSON.parse(localStorage.getItem('everypage'))
    var writeinformation = everypage.writeinformation + 1
    everypage.writeinformation = writeinformation;
    if(writeinformation == 1){
     this.isFirstDay = true
    }else{
      this.isFirstDay=false
    }
    localStorage.setItem("everypage", JSON.stringify(everypage));
    
    console.log(this,'这是mounted')
    var mdreferrer_title =  localStorage.getItem('title')
    if(mdreferrer_title == '' ||mdreferrer_title == undefined ||mdreferrer_title ==null){
      // mdreferrer = '没有上一页'
      mdreferrer_title = '没有上一页'
    }
    var title = this.$route.name;
    localStorage.setItem("mdreferrer_title",mdreferrer_title)
    localStorage.setItem("title",title)
    var url = this.$route.path;
    var url_path = this.$route.path;
    var is_first_Day = this.isFirstDay;
    var preview = 'MPViewScreen'
    // var mdreferrer = this.mdreferrer;
    // var mdreferrer_title = this.mdreferrer_title;
    this.$util.BuriedPoint(title,url,url_path,is_first_Day,preview,mdreferrer_title)
  },
  methods: {
    validationInput() {
      // console.log(this.validationInputV)
      // var that = this;
      if (this.validationInputV == this.codeValueImage) {
          this.rightok = true,
          this.agreeButton = false,
          this.validationTip = false;
      } else {
        this.validationInputV = this.validationInputV,
          this.rightok = false,
          this.agreeButton = true,
          this.validationTip = true;
      }
    },
    onGetVerifyCodeImage() {
      let reg = /^1[0-9]{10}$/.test(this.tel);
      if (reg == false) {
        Notify({
          type: "warning",
          message: "请输入正确的手机号码",
        });
        return;
      }
      // var that = this;
      this.getvalidationImage();
    },
    // 获取行为日志
    getApplyLog(params) {
      this.$server.getApplyLog(params).then((res) => {
        if (res.result == 1) {
          console.log("获取log成功____________________________");
        }
      });
    },
    onSubmit(values) {
      console.log("submit", values);
    },
    onConfirm(date) {
      console.log(date);
      this.inDateValue = this.$util.formatTime1(date);
      this.inDateValue = this.inDateValue.replace(/\//g, "-");
      this.showPicker = false;
    },
    onConfirm2(date) {
      console.log(date);
      this.outDateValue = this.$util.formatTime1(date);
      this.outDateValue = this.outDateValue.replace(/\//g, "-");
      this.showPicker2 = false;
    },
    onHerbalConfirm(e) {
      this.herbalItem = e;
      let arrItem = herbels.filter((item) => item.name == e);
      this.num = arrItem.num;
      this.name = e; //中药服数
      this.showHerbalPicker = false;
    },
    onHerbalChange() {},
    showErrorMsg(str) {
      switch (str) {
        case "userMrNo":
          Notify({
            type: "warning",
            message: mrNoHint,
          });
          break;
        case "userFlowNo":
          Notify({
            type: "warning",
            message: flowNoHint,
          });
          break;
        case "phoneNo":
          Notify({
            type: "warning",
            message: "请输入正确的手机号码",
          });
          break;
        default:
          break;
      }
    },
    radioClick(e) {
      if (e == 1) {
        this.isShowOutDate = true;
      } else if (e == 2) {
        this.isShowOutDate = false;
      }
    },
    /**
     * 住院号码输入
     */
    inputMrNo(e) {
      isRegValid(this, e, mrNoRule, "alertMrNo");
    },
    /**
     * 流水号输入
     */
    inputFlowNo(e) {
      isRegValid(this, e, tmpNoRole2, "alertFlowNo");
    },
    /**
     * 流水号输入
     */
    inputPhoneNo(e) {
      console.log(e)
      if( this.codeText == "获取验证码"){
        let rule = "^1[0-9]{10}$";
      isRegValid(this, e, rule, "alertPhoneNo");
      }else{
        console.log('现在这里有倒计时')
      }
      
    },
    /**
     * 获取验证码
     */
    getSmsCode() {
      this.disabledCode = true;
      this.validation = false,
      this.validationInputV = '',
      this.rightok = false,
      this.agreeButton = true
      console.log("发送验证码");
      let that = this;
      
      let subNumber = 60;
      verifyCodeTime(this, subNumber);
      let params = {
        telNo: this.tel,
        captcha:this.captchaImage,
      };
      this.$server.getVerifyCode(params).then((res) => {
        console.log(res);
        if (res.result == 1) {
          console.log("下发验证码");
          Notify({
            type: "success",
            message: "验证码发送成功",
          });
          let codeValue = res.code.toLowerCase();
          console.log("codeValue:" + codeValue);
          if (codeValue != null) {
            phoneJson[that.phoneNo] = codeValue;
          }
        } else {
           Notify({
            type: "warning",
            message: res.msg,
          });
          that.codeText = "获取验证码";
          clearInterval(intervalProcess);
        }
      });
    },

    next() {
      console.log("下一步");

      this.valueVerify();
    },
    /**
     * 数值验证
     */
    valueVerify() {
      if (this.isYPD) {
        if (this.showVisitCard) {
          // 就诊卡号验证patientFlowNo
          if (this.$util.isNullString(this.hosMrNo)) {
            Notify({
              type: "warning",
              message: "请输入" + this.labelMrNo,
            });
            return;
          }
          if (this.alertMrNo == "info-o") {
            Notify({
              type: "warning",
              message: "请输入" + mrNoHint,
            });
            return;
          }
          // 就诊日期验证
          if (this.inDateValue == "") {
            Notify({
              type: "warning",
              message: "请选择就诊日期",
            });
            return;
          }
          // 科室验证
          if (this.hosDepRequired && this.$util.isNullString(this.hosDep)) {
            Notify({
              type: "warning",
              message: "请输入" + this.userHosDep,
            });
            return;
          }
        }
        // 手机号码验证
        if (
          this.$util.isNullString(this.tel) ||
          this.alertPhoneNo == "info-o"
        ) {
          Notify({
            type: "warning",
            message: "请输入正确的手机号码",
          });
          return;
        }
        var md5Code = md5(this.verifyCode);

        // serviceCode 从phoneJSON中根据手机号取出，如果手机号有变化，servicecode为空
        var serviceCode = phoneJson[this.phoneNo];
        if (md5Code == serviceCode) {
          this.codeText = "获取验证码";
          //清除定时任务
          clearInterval(intervalProcess);
          // this.verifyCode = "";
          if (this.agree == false) {
            Notify({
              type: "warning",
              message: "请滑动到底部，阅读并同意相关条款!!",
            });
            return;
          }
          this.submit();
        } else {
          Notify({
            type: "warning",
            message: "手机号或验证码不正确",
          });
          return;
        }
      } else {
        if (this.$util.isNullString(this.hosMrNo)) {
          Notify({
            type: "warning",
            message: "请输入" + this.labelMrNo,
          });
          return;
        }
        if (this.alertMrNo == "info-o") {
          Notify({
            type: "warning",
            message: "请输入" + mrNoHint,
          });
          return;
        }
        let selectHbsType = hosItem.selectHbsType;
        let hosLimitOnce = selectHbsType.hosInfo.hosLimitOnce;
        if (hosLimitOnce == 1) {
          this.getRecordList();
        } else {
          this.verifyInfo();
        }
      }
    },
    initData() {
      // 判断病案号是否保存的参数，值大于0不本地保存
      let selectHbsType = hosItem.selectHbsType;
      let hosMrNoDiffent = selectHbsType.hosInfo.hosMrNoDiffent;
      if (userInfo.hosId == hosItem.hosId) {
        if (hosMrNoDiffent != null && hosMrNoDiffent > 0) {
          this.hosMrNo = "";
        } else {
          this.hosMrNo = this.$util.normalString(userInfo.hosMrNo);
        }

        this.inDateValue = this.$util.normalString(userInfo.inDateValue);
        this.outDateValue = this.$util.normalString(userInfo.outDateValue);
        this.tel = this.$util.normalString(userInfo.tel);
        // this.hosDep = this.$util.normalString(userInfo.hosDep);
        this.patientFlowNo = this.$util.normalString(userInfo.patientFlowNo);
      }
    },
    compareDate(d1, d2) {
      return new Date(d1) > new Date(d2);
    },
    /**
     * 获取住院记录
     */
    getHosMrRecords() {
      let hosId = hosItem.hosId;
      let idCardNo = this.$route.params.idCardNo;
      let patientName = this.$route.params.patientName;
      let params = {
        hosId: hosId,
        idCard: idCardNo,
        patientName: patientName,
      };
      this.$server.getHosMrRecords(params).then((res) => {
        if (res.result == 1) {
          let params = res.params;
          let defaultHistory = res.default;
          if(this.$util.isNullString(defaultHistory.patientFlowId) == false){
            this.patientFlowNo = defaultHistory.patientFlowId
        }
          let array = new Array();
          // if(params.length>0){
          // for (let i in params) {
            console.log('没有数据')
          if(params != null){
            for (var i=0; i<params.length; i++) {
            let obj = {
              year: i,
              hosRecords: params[i],
            };
            array.push(obj);
            console.log(array);
          }
          }
          

          // }
          if ((defaultHistory != null) & (defaultHistory != undefined)) {
            this.isShowHistoryBtn = true;
            this.defaultHistory = defaultHistory;
            this.hosRecordIndate = defaultHistory.hosInDate.substr(0, 10);
            this.hosRecordOutdate = defaultHistory.hosOutDate.substr(0, 10);
            this.hosRecords = array.reverse();
            // that.setData({
            // 	defaultHistory: defaultHistory,
            // 	hosRecordIndate: defaultHistory.hosInDate.substr(0, 10),
            // 	hosRecordOutdate: defaultHistory.hosOutDate.substr(0, 10),
            // 	hosRecords: array.reverse(),
            // 	showHistory: true,
            // 	// userMrId: util.normalString(defaultHistory.mrNo),
            // 	// alertMrNo: true,
            // })
            // infoItem.userMrId = that.data.userMrId;
            // setArrValue();
          }
        }
      });
    },
    addHistory(e) {
      var hosRecord = e;
      this.hosMrNo = this.$util.normalString(hosRecord.mrNo);
      this.inDateValue = hosRecord.hosInDate.substr(0, 10);
      this.outDateValue = hosRecord.hosOutDate.substr(0, 10);
      if (this.hosDepList.length < 1) {
        this.hosDep = this.$util.normalString(hosRecord.patientHosDep);
      }
      this.isShowHistory = false;
      Notify({
        type: "success",
        message: "添加成功",
      });
    },
    /**
     * 获取是否有申请记录
     */
    getRecordList() {
      let hosId = hosItem.hosId;
      let idCardNo = this.$route.params.idCardNo;
      let patientName = this.$route.params.patientName;
      let params = {
        hosId: hosId,
        userMrNo: this.hosMrNo,
        patientCardId: idCardNo,
        patientName: patientName,
      };

      this.$server.getRecordList(params).then((res) => {
        if (res.result == 1) {
          let count = res.count;
          if (count > 0) {
            Dialog({
              title: "标题",
              message:
                "您已在病案通线上申请过业务，如需多次申请需前往医院窗口办理",
            });
            return;
          } else {
            //验证info
            this.verifyInfo();
          }
        }
      });
    },
    /**
     * 获取科室列表
     */
    getHosDepList() {
      let params = {
        hosId: hosItem.hosId,
      };
      this.$server.getHosDepList(params).then((res) => {
        console.log("科室接口");
        console.log(res.step);
        this.step = res.step;
        console.log(step);
        let hosDepList = res.hospitalDepList;
        this.hosDepList = hosDepList;
        if (this.step == 2) {
          console.log("科室有两层");
          for (var i=0;i<this.hosDepList.length;i++) {
            console.log(this.hosDepList[i].children);
            if (
              this.hosDepList[i].children == "" ||
              this.hosDepList[i].children == null
            ) {
              console.log("这个第二层没数据",'9990');
              this.hosDepList[i].children.push({
                depId: "",
                hosId: "",
                text: "",
              });
              // this.hosDepList[i].children[0].depId=''
              // this.hosDepList[i].children[0].text=''
              console.log(this.hosDepList[i].children);
            }
            console.log("打入敌人内容不",'9992');
          }
        }
        console.log(this.hosDepList);
        if (hosDepList != null && hosDepList.length > 0) {
          this.depInputDisable = true;
          this.showArrow = true;
          this.readonlyDep = true;
          this.hosDepName = hosDepList.map((item) => item.text);
          this.depPlaceholder = "点击选择" + this.userHosDep;
        }
      });
    },

    /**
     * 获取验证码图片
     */
    getvalidationImage() {
      let params = {
        telNo: this.tel,

      };
      this.$server.getvalidationImage(params).then((res) => {
        console.log("获取验证码图片");
        console.log(res);
        (this.validation = true),
          (this.validationImage = res.codeImg),
          console.log(this.validationImage);
        (this.captchaImage = res.captcha),
          (this.codeValueImage = res.codeValue);
      });
    },

    /**
     * 点击选择科室
     */
    selectDep(e) {
      if (this.hosDepList.length > 0) {
        console.log(e);
        this.showDepPicker = true;
      }
    },
    onConfirmDep(e, index) {
      this.showDepPicker = false;
      console.log(e);
      console.log(index);
      if (this.step == 2) {
        console.log(e);
        console.log(index[0]);
        console.log(index[1]);

        if (e[1] != "") {
          this.hosDep = e[0] + "-" + e[1];
          this.patientHosDepCode =
            this.hosDepList[index[0]].children[index[1]].depId;
        } else {
          this.hosDep = e[0];
          // this.patientHosDepCode = this.hosDepList[0].depId
          this.patientHosDepCode = this.hosDepList[index[0]].depId;
        }
        console.log(this.patientHosDepCode);
        // console.log((this.hosDepList[index[0]].children)[index[1]].depId)
        // let arrItem = this.hosDepList
        // let arrItem = this.hosDepList.filter(item => item.text == e);
        // console.log(arrItem)
        // this.patientHosDepCode = arrItem[0].depId;
      } else {
        console.log(e.text);
        this.hosDep = e.text;
        this.patientHosDepCode = this.hosDepList[index].depId;
      }
    },
    onChange(index) {
      console.log(index);
    },
    verifyInfo() {
      let selectHbsType = hosItem.selectHbsType;
      let type = selectHbsType.type;
      if (this.$util.isNullString(this.patientFlowNo) && hosFlowId == 1) {
        Notify({
          type: "warning",
          message: "请输入" + this.flowName,
        });
        return;
      }
      if (this.alertFlowNo == "info-o" && hosFlowId == 1) {
        Notify({
          type: "warning",
          message: "请输入" + flowNoHint,
        });
        return;
      }
      if (type == "HB_TYPE_MR_C") {
        // if (this.inDateValue == "") {
        //   Notify({
        //     type: "warning",
        //     message: "请选择开始时间",
        //   });
        //   return;
        // }
        if (this.outDateValue == "") {
          Notify({
            type: "warning",
            message: "请选择截止时间",
          });
          return;
        }
        if (this.compareDate(this.inDateValue, this.outDateValue)) {
          Notify({
            type: "warning",
            message: "截止时间不能小于于开始时间",
          });
          return;
        }
      } else {
        if (this.inDateValue == "" && this.requiredInDate) {
          Notify({
            type: "warning",
            message: "请选择入院时间",
          });
          return;
        }
        if (this.outDateValue == "" && this.requiredOutDate && this.radio == 1) {
          Notify({
            type: "warning",
            message: "请选择出院时间",
          });
          return;
        }
        if (this.compareDate(this.inDateValue, this.outDateValue)) {
          Notify({
            type: "warning",
            message: "出院时间不能小于入院时间",
          });
          return;
        }
        if (this.hosDepRequired && this.$util.isNullString(this.hosDep)) {
          Notify({
            type: "warning",
            message: "请输入" + this.userHosDep,
          });
          return;
        }
      }

      if (this.$util.isNullString(this.tel) || this.alertPhoneNo == "info-o") {
        Notify({
          type: "warning",
          message: "请输入正确的手机号码",
        });
        return;
      }
      var md5Code = md5(this.verifyCode);

      // serviceCode 从phoneJSON中根据手机号取出，如果手机号有变化，servicecode为空
      var serviceCode = phoneJson[this.phoneNo];

      // console.log(md5Code);
      // console.log(serviceCode);

      if (md5Code == serviceCode) {
        this.codeText = "获取验证码";
        //清除定时任务
        clearInterval(intervalProcess);
        this.verifyCode = "";
        if (this.$util.isNullString(this.patientFlowNo)==false || hosFlowId == 1) {
          hosItem.patientFlowNo = this.patientFlowNo;
          userInfo.patientFlowNo = this.patientFlowNo;
        }
        hosItem.inHospitalDate = this.inDateValue.replace(/\//g, "-");
        userInfo.inDateValue = this.inDateValue.replace(/\//g, "-");

        hosItem.userMrId = this.hosMrNo;
        userInfo.hosMrNo = this.hosMrNo;
        if (this.radio == 2) {
          hosItem.outHospitalDate = "";
          userInfo.outDateValue = "";
        } else {
          hosItem.outHospitalDate = this.outDateValue.replace(/\//g, "-");
          userInfo.outDateValue = this.outDateValue.replace(/\//g, "-");
        }

        hosItem.patientTelNo = this.tel;
        hosItem.patientHosDep = this.hosDep;
        hosItem.patientHosDepCode = this.patientHosDepCode;
        userInfo.tel = this.tel;
        userInfo.hosDep = this.hosDep;
        userInfo.hosId = hosItem.hosId;
        localStorage.setItem("UserInfo", JSON.stringify(userInfo));
        localStorage.setItem("HosItem", JSON.stringify(hosItem));
        let logparams = {
          userId: localStorage.getItem("userId"),
          phoneV: localStorage.getItem("os"),
          wxV: localStorage.getItem("version"),
          wxId: localStorage.getItem("wxId"),
          pId: 3,
          type: localStorage.getItem("selectTypeLog"),

          // hosId: hosId,
          // bType: selectHbsType.type,
        };
        this.getApplyLog(logparams);
        this.$router.push("/purpose");
      } else {
        Notify({
          type: "warning",
          message: "手机号或验证码不正确",
        });
        return;
      }
    },
    submit() {
      let userId = localStorage.getItem("userId");
      let wxId = localStorage.getItem("wxId");
      let userMrId = this.hosMrNo;
      let inHospitalDate = this.inDateValue.replace(/\//g, "-");
      let patientName = hosItem.patientName;
      let patientCardId = hosItem.patientCardId;
      let patientCardType = hosItem.patientCardType;
      let patientTelNo = this.tel;
      let applyMode = 0;
      let proposerName = "";
      let proposerCardId = "";
      let proposerCardType = "";
      let userAddrId = "";
      let receiverName = hosItem.receiverName;
      let receiverTel = hosItem.receiverTel;
      let receiverProvince = hosItem.receiverProvince;
      let receiverCity = hosItem.receiverCity;
      let receiverDistrict = hosItem.receiverDistrict;
      let receiverAddress = hosItem.receiverAddress;
      let selfPickupPlace = hosItem.selfPickupPlace; //自提点
      let selectUseExpressType = hosItem.selectUseExpressType;
      let printType = selectUseExpressType.bId;
      let chmPageNum = this.num; //中草药份数
      let patientHosDep = this.$util.normalString(hosItem.patientHosDep);
      let requestDesc = filterStr(this.message);
      let printInvoice = hosItem.isPrintInvoice;
      let imageJsonData = JSON.stringify(hosItem.servicePathArr);
      let orderTakingPartId = this.$util.normalString(hosItem.expressId);
      let vLibId = hosItem.vLibId;
      let otherNeedFlag = this.name;
      let patientFlowId = this.patientFlowNo;
      let patientHosDepCode = this.patientHosDepCode;
      let params = {
        userId: userId,
        hosId: hosItem.hosId,
        wxId: wxId,
        userMrId: userMrId,
        inHospitalDate: inHospitalDate,
        patientName: patientName,
        patientCardId: patientCardId,
        patientCardType: patientCardType,
        patientTelNo: patientTelNo,
        applyMode: applyMode,
        proposerName: proposerName,
        proposerCardId: proposerCardId,
        proposerCardType: proposerCardType,
        userAddrId: userAddrId,
        receiverName: receiverName,
        receiverTel: receiverTel,
        receiverProvince: receiverProvince,
        receiverCity: receiverCity,
        receiverDistrict: receiverDistrict,
        receiverAddress: receiverAddress,
        selfPickupPlace: selfPickupPlace,
        printType: printType,
        chmPageNum: chmPageNum,
        otherNeedFlag: otherNeedFlag,
        patientHosDep: patientHosDep,
        requestDesc: requestDesc,
        printInvoice: printInvoice,
        imageJsonData: imageJsonData,
        orderTakingPartId: orderTakingPartId,
        vLibId: vLibId,
        patientFlowId:patientFlowId,
        patientHosDepCode: patientHosDepCode,
      };
      this.disabledSubmit = true;
      this.isLoading = true;
      this.$server.create(params).then((res) => {
        console.log(res);
        if (res.result == 1) {
          let currentTime = new Date().getTime();
          localStorage.setItem("localTime", currentTime.toString());
          let requestId = res.requestId;
          let prePayFlag = res.prePayFlag;
          if (prePayFlag == 1) {
            this.$router.push("/pay/" + requestId + "/" + "1");
          } else {
            this.$router.push("/pay/" + requestId + "/" + "2");
          }
        }
        this.disabledSubmit = false;
        this.isLoading = false;
      });
      return;
    },
  },
};
//必填项判断
function requiredJudgeInit(selectHbsType, that) {
  if (
    selectHbsType.requiredParam != null &&
    selectHbsType.requiredParam.requestRequiredList != null &&
    selectHbsType.requiredParam.requestRequiredList.length > 0
  ) {
    let reqList = selectHbsType.requiredParam.requestRequiredList;
    for (let i in reqList) {
      let obj = reqList[Number(i)];
      // let strObj = decodeURIComponent(obj);
      // console.log(JSON.parse(strObj));
      // let requiredObj = JSON.parse(strObj);
      if (obj == "userPatientHosDep") {
        // let isRequired = requiredObj.isRequired;
        // that.userHosDep = requiredObj.value;
        // if (isRequired == 1) {
        //   that.hosDepRequired = true;
        //   that.depPlaceholder = "请输入" + that.userHosDep;
        // } else {
        //   that.hosDepRequired = false;
        //   that.depPlaceholder = "如不清楚可不填写";
        // }
        that.hosDepRequired = true;
        that.depPlaceholder = "请输入" + that.userHosDep;
      } else if(obj == 'userHosInDate'){
        that.requiredInDate = true;
        that.datePlaceholder1 = "请输入" + that.dateName1;
        // that.userHosDep = "科室/病区";
        // that.hosDepRequired = false;
        // that.depPlaceholder = "如不清楚可不填写";
      }else if(obj == 'userHosOutDate'){
        that.requiredOutDate = true;
        that.datePlaceholder2 = "请输入" + that.dateName2;
      }
    }
  } else {
    // that.userHosDep = "科室/病区";
    // that.hosDepRequired = false;
    that.depPlaceholder = "如不清楚可不填写";
  }
  if (
    selectHbsType.requiredParam != null &&
    selectHbsType.requiredParam.requestRequires != null &&
    selectHbsType.requiredParam.requestRequires.length > 0
  ) {
    let requestRequires = selectHbsType.requiredParam.requestRequires;
    for (let i in requestRequires) {
      console.log(Number(i));

      let obj = requestRequires[Number(i)];

      if (obj.name == "chinaHerbel") {
        that.herbalName = obj.value;
        herbels = obj.herbels;
        let arr = [];
        herbels.forEach((item) => {
          arr.push(item.name);
        });
        that.herbalNum = arr;
        that.herbalItem = arr[0];
        that.num = herbels[0].num;
        that.name = herbels[0].name;
      }
    }
  }
}

function isRegValid(that, inputValue, tmpRole, alertName) {
  console.log(alertName);
  var regName = new RegExp(tmpRole);
  console.log(regName);
  console.log(regName.test(inputValue));
  console.log(regName.exec(inputValue));
  if (regName.test(inputValue)) {
    that[alertName] = "";
    that.disabledCode = false;
  } else {
    that[alertName] = "info-o";
  }
}

function getCurrenDate() {
  var day2 = new Date();
  day2.setTime(day2.getTime());
  // var s2 = day2.getFullYear() + "/" + (day2.getMonth() + 1) + "/" + day2.getDate();

  return day2;
}

function addDate(date, days) {
  var d = new Date(date);
  d.setDate(d.getDate() + days);
  // var m = d.getMonth() + 1;
  return d;
}

function verifyCodeTime(that, count) {
  intervalProcess = setInterval(function () {
    if (count == 0) {
      that.codeText = "获取验证码";
      that.disabledCode = false;
      clearInterval(intervalProcess);
    } else {
      that.codeText = "(" + count + ")";
      count--;
    }
  }, 1000);
}
function filterStr(str) {
  if (str == null || str == undefined) {
    return "";
  } else return str.replace(/[\r\n]/g, "");
}
</script>

<style>
.info-content {
  margin-top: 80px;
}

.eg {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
  display: -webkit-flex;
  font-size: 14px;
  color: gray;
}

.input-group-title {
  margin: 0;
  padding: 16px;
  color: rgba(69, 90, 100, 0.6);
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}

/**
	 * 住院记录
	 */
.tips-history {
  width: 100%;
  background: rgba(249, 255, 249, 0.96);
  padding: 10px 0px 10px 20px;
}

.tips-history .tips-history_item {
  display: flex;
}

.tips-history .bottom-line {
  height: 1px;
  width: 100%;
  background: #1aac19;
  margin: 10px 0;
}

.tips-history .tips-history_item .tips-history_titleL {
  display: flex;
  display: -webkit-flex;
  font-size: 14px;
  color: #999;
}

.tips-history .tips-history_item .tips-history_titleR {
  position: absolute;
  color: #1aad19;
  font-size: 14px;
  right: 20px;
}

.tips-history .tips-history_item .tips-history_contentL {
  display: flex;
  display: -webkit-flex;
  font-size: 14px;
  color: #333;
  margin-right: 60px;
}

.tips-history .tips-history_item .tips-history_contentR {
  position: absolute;
  color: #f96a0e;
  font-size: 13px;
  right: 15px;
  border: 1px solid #f96a0e;
  padding: 1px 8px;
  border-radius: 2px;
}

.hos-history_flayer {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.7);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}

.flayer_content {
  width: 100%;
  max-height: 70%;
  background-color: white;
  position: absolute;
  bottom: 0;
  right: 0;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  padding: 15px 0;
}

.flayer_record {
  padding: 0 0 0 10px;
  background: #f5f8fa;
  margin: 10px;
  border-radius: 2px;
}

.flayer_content .flayer_title {
  text-align: center;
  padding: 10px;
  font-size: 18px;
  font-weight: 400;
  color: #333;
  line-height: 25px;
}

.flayer_title_say {
  font-size: 15px;
  color: #f44336;
  text-align: center;
  padding: 0 50px;
  font-weight: 400;
  line-height: 21px;
}

.flayer_latest_note {
  display: flex;
  /* width: 100%; */
  margin: 15px 10px;
  padding: 5px;
  background-color: #f5f8fa;
}

.flayer_latest_note_l {
  display: flex;
  width: 50px;
  flex-direction: column;
  font-size: 20px;
  align-self: center;
}

.flayer_latest_note_t1 {
  color: #f96a0e;
}

.flayer_latest_note_t2 {
  color: #333;
}

.flayer_latest_note_r {
  width: 100%;
  padding: 10px 5px;
}

.flayer_latest_note_no {
  display: flex;
}

.flayer_latest_note_no .name {
  display: flex;
  width: 57.5px;
  height: 17.5px;
  background: rgba(255, 234, 197, 1);
  text-align: center;
  align-self: center;
  margin-right: 10px;
}

.flayer_latest_note_no .name .name-text {
  font-size: 12px;
  font-family: HiraginoSansGB;
  font-weight: normal;
  color: rgba(249, 106, 14, 1);
  line-height: 18px;
  letter-spacing: 5px;
  text-align: center;
  margin-left: 5px;
}

.flayer_latest_note_no .name .name2-text {
  font-size: 12px;
  font-family: HiraginoSansGB;
  font-weight: normal;
  color: rgba(249, 106, 14, 1);
  line-height: 18px;
  text-align: center;
  margin-left: 5px;
}

.flayer_latest_note_no .num {
  font-size: 14px;
  color: #333;
  font-family: HiraginoSansGB;
  font-weight: bold;
  line-height: 21px;
  align-self: center;
}

.flayer_latest_note_no .time {
  font-size: 14px;
  font-family: HiraginoSansGB;
  font-weight: normal;
  color: #333;
  line-height: 21px;
}

.flayer_latest_note_no .name2 {
  width: 57.5px;
  height: 17.5px;
  font-size: 12px;
  font-family: HiraginoSansGB;
  font-weight: normal;
  color: rgba(249, 106, 14, 1);
  line-height: 18px;
  background: rgba(255, 234, 197, 1);
  margin-right: 10px;
  padding: 2.5px;
  text-align: center;
  align-self: center;
}

.btn-one-add {
  color: #f96a0e;
  font-size: 12px;
  border: 1px solid #f96a0e;
  padding: 2.5px 6px;
  border-radius: 2px;
  margin-left: auto;
}

.hos_record {
  display: flex;
}

.year_circle {
  width: 50px;
  height: 50px;
  background: #36b489;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  /* align-self: center; */
  margin-left: 15px;
  margin-top: 10px;
  flex-shrink: 0;
  color: #fff;
  font-size: 15px;
}

.flayer_item {
  padding: 15px 0 15px 10px;
  position: relative;
}

.flayer_item::before {
  content: " ";
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 1px;
  border-top: 0.5px solid #e1e1e1;
  color: #e1e1e1;
}

.flayer_item:first-child:before {
  display: none;
}

.time-line-list {
  width: 100%;
}

/* 住院记录 */

.btn-history {
  color: #f96a0e;
  font-size: 12px;
  border: 1px solid #f96a0e;
  padding: 2.5px 4px;
  border-radius: 2px;
  margin-left: auto;
}

.hos-note-year {
  display: flex;
  flex-direction: column;
}

.hos-note-year-head {
  width: 50px;
  height: 24px;
  color: #333;
  font-weight: 500;
  font-size: 16px;
  border: 1px solid #333;
  border-radius: 2px;
  text-align: center;
  margin-left: 10px;
}

/*行样式*/

.note-item {
  display: flex;
}

/*时间轴*/

.note-item .dotline {
  width: 50px;
  position: relative;
}

/*竖线*/

.note-item .dotline .line {
  width: 1px;
  height: 100%;
  background: #999;
  position: absolute;
  top: -10px;
  left: 35px;
}

/*圆点*/

.note-item .dotline .dot {
  width: 8px;
  height: 8px;
  background: #4cc04b;
  position: absolute;
  top: 10px;
  left: 26.5px;
  border-radius: 50%;
  border: 5px solid #e3ffe3;
}

.add-hover {
  background-color: rgba(249, 106, 14, 0.08);
}
.bg-my-gray {
  background-color: #efeff4;
}
.tip-con-info {
  /* width: 300px; */
  height: 40px;
  border: 1px solid #dddddd;
  line-height: 40px;
  margin: 20px auto;
  border-radius: 6px;
  position: relative;
}
.inputVer {
  width: 260px;
  border: none;
  border-radius: 6px;
  text-align: left;
  /* margin: 20px auto; */
  line-height: 40px;
  height: 40px;
}
.rightok {
  position: absolute;
  width: 20px;
  height: 20px;
  top: 10px;
  right: 10px;
}
.floatDivInfo {
  width: calc(100% - 15px * 2);
  height: 350px;
  background-color: white;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
  /*margin-top: 80px;*/
  border-radius: 5px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
.button-2{
    width: 200rpx;
    background-color: #1aac19;
    color: white;
    /* padding: 0rpx 100rpx; */
}
.button-no-2{
    width: 200rpx;
    background-color: #bebebe;
    color: white;
    /* padding: 0rpx 100rpx; */
}
.tipInputVer{
  text-align: center;
  color: red;
  font-size: 14px;
}
</style>
